import React from 'react'
import { Container, Wrapper, HeaderRow, TitleBlock, Title, TitleAccent, CardContainer, GridColumn } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'
import { motion } from 'framer-motion'

const Projects = ({ openModal, setOpenModal }) => {
  // Distribute projects across 4 columns for the staggered grid
  const columns = [[], [], [], []];
  projects.forEach((project, index) => {
    columns[index % 4].push({ ...project, originalIndex: index });
  });

  return (
    <Container id="projects">
      <Wrapper
        as={motion.div}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <HeaderRow>
          <TitleBlock>
            <Title>
              <TitleAccent>PROJECTS</TitleAccent>
            </Title>
          </TitleBlock>
        </HeaderRow>
        <CardContainer>
          {columns.map((col, colIndex) => (
            <GridColumn key={colIndex} $offset={colIndex % 2 === 1}>
              {col.map((project) => (
                <ProjectCard
                  key={project.id}
                  project={project}
                  openModal={openModal}
                  setOpenModal={setOpenModal}
                  index={project.originalIndex}
                />
              ))}
            </GridColumn>
          ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects